import * as Yup from "yup";

export const ForgottenPasswordResetFormSchema = {
    newPassword: Yup.string()
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()])[A-Za-z\d@$!%*?&()]{12,}$/,
            "Password must contain at least 12 characters, a mix of lower and upper case, at least 1 number and 1 special character (@$!%*?&())."
        )
        .required("please enter a new password"),
    confirmNewPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Must confirm password before submitting"),
};

export type ForgottenPasswordResetFormValues = {
    newPassword: string;
    confirmNewPassword: string;
};

// 01/05/23 When creating a 'new' password, the user is actually resetting their default password
export type CreatePasswordFormValues = ForgottenPasswordResetFormValues;
